export default function PHP_htmlentities() {
  return (
    <div>
      <h1>PHP_htmlentities</h1>
    </div>
  );
}
